import { render, staticRenderFns } from "./TencentPlayer.vue?vue&type=template&id=bb6e9a98&scoped=true&"
import script from "./TencentPlayer.vue?vue&type=script&lang=js&"
export * from "./TencentPlayer.vue?vue&type=script&lang=js&"
import style0 from "./TencentPlayer.vue?vue&type=style&index=0&id=bb6e9a98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb6e9a98",
  null
  
)

export default component.exports